import useSWR from "swr";
import axios from "axios";

function useBroadcast() {
  return useSWR(`${process.env.REACT_APP_API_URL}/broadcasts`, async (url) => {
    const response = await axios.get(url);

    return response.data;
  });
}

export default useBroadcast;
